import Store from 'lightningjs-redux';
import { getDeviceVersion, getDeviceBrand, getDeviceModel } from '../../logic/app/app.selectors';

const mapControllers = instance => ({
  deviceVersion: {
    selector: getDeviceVersion,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.deviceVersion = value;
    },
  },
  deviceBrand: {
    selector: getDeviceBrand,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.deviceBrand = value;
    },
  },
  deviceModel: {
    selector: getDeviceModel,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.deviceModel = value;
    },
  },
});

export default Store.control(mapControllers);
